import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useParams, useHistory } from "react-router-dom";

import clsx from "clsx";

import { makeStyles, Paper, useMediaQuery } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

import ContactDrawer from "../ContactDrawer";
import MessageInput from "../MessageInput/";
import TicketHeader from "../TicketHeader";
import TicketInfo from "../TicketInfo";
import TicketActionButtons from "../TicketActionButtonsCustom";
import MessagesList from "../MessagesList";
import api from "../../services/api";
import { ReplyMessageProvider } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { ForwardMessageProvider } from "../../context/ForwarMessage/ForwardMessageContext";

import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TagsContainer } from "../TagsContainer";
import { isNil } from 'lodash';
import { EditMessageProvider } from "../../context/EditingMessage/EditingMessageContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const drawerWidth = 320;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
    padding: 10,
    gap: 10,
    background: "transparent",
  },

  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    borderRadius: 24,
    borderLeft: "0",
    marginRight: -drawerWidth,
    border: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.16)" : "rgba(255,255,255,0.08)"}`,
    background:
      theme.mode === "light"
        ? "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(248,250,252,0.94) 100%)"
        : "linear-gradient(180deg, rgba(15,23,42,0.88) 0%, rgba(2,6,23,0.92) 100%)",
    boxShadow:
      theme.mode === "light"
        ? "0 18px 42px rgba(15, 23, 42, 0.08)"
        : "0 18px 42px rgba(2, 6, 23, 0.34)",
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
      borderRadius: 20,
      padding: 0,
    },
  },

  mainWrapperShift: {
    borderTopRightRadius: 24,
    borderBottomRightRadius: 24,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
    [theme.breakpoints.down('md')]: {
      marginRight: 0,
      borderRadius: 20,
    },
  },

  conversationArea: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
  },

  dragOverlay: {
    position: "absolute",
    inset: 0,
    zIndex: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: theme.mode === "light"
      ? "rgba(15, 23, 42, 0.16)"
      : "rgba(2, 6, 23, 0.52)",
    backdropFilter: "blur(4px)",
    border: `2px dashed ${theme.palette.primary.main}`,
    borderRadius: 18,
    pointerEvents: "none",
    padding: theme.spacing(2),
  },

  dragOverlayContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(2.5, 3),
    borderRadius: 16,
    color: theme.palette.primary.main,
    background: theme.mode === "light"
      ? "rgba(255,255,255,0.92)"
      : "rgba(15,23,42,0.88)",
    boxShadow: theme.mode === "light"
      ? "0 10px 30px rgba(15, 23, 42, 0.12)"
      : "0 10px 30px rgba(2, 6, 23, 0.36)",
    textAlign: "center",
    fontWeight: 600,
    maxWidth: 360,
    width: "100%",
  },
}));

const Ticket = () => {
  const { ticketId } = useParams();
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyles();

  const { user, socket } = useContext(AuthContext);
  const { setTabOpen } = useContext(TicketsContext);


  const [drawerOpen, setDrawerOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [contact, setContact] = useState({});
  const [ticket, setTicket] = useState({});
  const [dragDropFiles, setDragDropFiles] = useState([]);
  const [isConversationDragActive, setIsConversationDragActive] = useState(false);
  const conversationDragCounter = useRef(0);
  const { companyId } = user;

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchTicket = async () => {
        try {

          if (!isNil(ticketId) && ticketId !== "undefined") {

            const { data } = await api.get("/tickets/u/" + ticketId);

            setContact(data.contact);
            // setWhatsapp(data.whatsapp);
            // setQueueId(data.queueId);
            setTicket(data);
            if (["pending", "open", "group"].includes(data.status)) {
              setTabOpen(data.status);
            }
            setLoading(false);
          }
        } catch (err) {
          history.push("/tickets");   // correção para evitar tela branca uuid não encontrado Feito por Altemir 16/08/2023
          setLoading(false);
          toastError(err);
        }
      };
      fetchTicket();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [ticketId, user, history]);

  useEffect(() => {
    if (!ticket && !ticket.id && ticket.uuid !== ticketId && ticketId === "undefined") {
      return;
    }

    if (user.companyId) {
      //    const socket = socketManager.GetSocket();

      const onConnectTicket = () => {
        socket.emit("joinChatBox", `${ticket.id}`);
      }

      const onCompanyTicket = (data) => {
        if (data.action === "update" && data.ticket.id === ticket?.id) {
          setTicket(data.ticket);
        }

        if (data.action === "delete" && data.ticketId === ticket?.id) {
          history.push("/tickets");
        }
      };

      const onCompanyContactTicket = (data) => {
        if (data.action === "update") {
          // if (isMounted) {
          setContact((prevState) => {
            if (prevState.id === data.contact?.id) {
              return { ...prevState, ...data.contact };
            }
            return prevState;
          });
          // }
        }
      };

      socket.on("connect", onConnectTicket)
      socket.on(`company-${companyId}-ticket`, onCompanyTicket);
      socket.on(`company-${companyId}-contact`, onCompanyContactTicket);

      // FIX: Se o socket já estiver conectado (ex: mobile wake-up ou navegação),
      // forçamos a entrada na sala do ticket, pois o evento "connect" não dispara novamente.
      if (socket.connected) {
        onConnectTicket();
      }

      return () => {

        socket.emit("joinChatBoxLeave", `${ticket.id}`);
        socket.off("connect", onConnectTicket);
        socket.off(`company-${companyId}-ticket`, onCompanyTicket);
        socket.off(`company-${companyId}-contact`, onCompanyContactTicket);
      };
    }
  }, [ticketId, ticket, history]);

  const handleDrawerOpen = useCallback(() => {
    setDrawerOpen(true);
  }, []);

  const handleDrawerClose = useCallback(() => {
    setDrawerOpen(false);
    if (isMobile) {
      setTabOpen("open");
      history.push("/tickets");
    }
  }, [history, isMobile, setTabOpen]);

  const handleQuickMessageSelect = (quickMessage) => {
    try {
      if (quickMessage.message) {
        // Disparar evento que o MessageInput vai escutar
        const event = new CustomEvent('insertQuickMessage', {
          detail: { message: quickMessage.message }
        });
        window.dispatchEvent(event);

      }

      if (quickMessage.mediaPath) {
        // Tratar mídia se necessário
      }
    } catch (error) {
      console.error("Erro ao inserir resposta rápida:", error);
      toastError("Erro ao inserir resposta rápida");
    }
  };

  const eventHasFiles = useCallback((event) => {
    const eventTypes = event?.dataTransfer?.types;

    if (!eventTypes) {
      return false;
    }

    return Array.from(eventTypes).includes("Files") || Array.from(eventTypes).includes("application/x-moz-file");
  }, []);

  const handleConversationDragEnter = useCallback((event) => {
    if (!eventHasFiles(event)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    conversationDragCounter.current += 1;
    setIsConversationDragActive(true);
  }, [eventHasFiles]);

  const handleConversationDragOver = useCallback((event) => {
    if (!eventHasFiles(event)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (!isConversationDragActive) {
      setIsConversationDragActive(true);
    }
  }, [eventHasFiles, isConversationDragActive]);

  const handleConversationDragLeave = useCallback((event) => {
    if (!eventHasFiles(event)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    conversationDragCounter.current = Math.max(conversationDragCounter.current - 1, 0);

    const currentTarget = event.currentTarget;
    const relatedTarget = event.relatedTarget;

    if (currentTarget && relatedTarget && currentTarget.contains(relatedTarget)) {
      return;
    }

    if (conversationDragCounter.current === 0) {
      setIsConversationDragActive(false);
    }
  }, [eventHasFiles]);

  const handleConversationDrop = useCallback((event) => {
    if (!eventHasFiles(event)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    conversationDragCounter.current = 0;
    setIsConversationDragActive(false);

    const droppedFiles = Array.from(event.dataTransfer?.files || []).filter((file) => file instanceof File);

    if (droppedFiles.length > 0) {
      setDragDropFiles(droppedFiles);
    }
  }, [eventHasFiles]);

  const renderMessagesList = () => {
    return (
      <>
        <MessagesList
          isGroup={ticket.isGroup}
          whatsappId={ticket.whatsappId}
          queueId={ticket.queueId}
          channel={ticket.channel}
          ticketStatus={ticket.status}
          disableInternalDropZone
        >
        </MessagesList>
        <MessageInput
          ticketId={ticket.id}
          ticketStatus={ticket.status}
          ticketChannel={ticket.channel}
          droppedFiles={dragDropFiles}
          contactId={contact.id}
          whatsappId={ticket.whatsappId}
        />
      </>
    );
  };


  return (
    <div className={classes.root} id="drawer-container">
      <Paper
        variant="outlined"
        elevation={0}
        className={clsx(classes.mainWrapper, {
          [classes.mainWrapperShift]: drawerOpen && !isMobile,
        })}
      >
        {/* <div id="TicketHeader"> */}
        <TicketHeader loading={loading}>
          {ticket.contact !== undefined && (
            <div id="TicketHeader">
              <TicketInfo
                contact={contact}
                ticket={ticket}
                onClick={handleDrawerOpen}
              />
            </div>
          )}
          <TicketActionButtons
            ticket={ticket}
            contact={contact}
            onQuickMessageSelect={handleQuickMessageSelect}
          />
        </TicketHeader>
        {/* </div> */}
        <div
          className={classes.conversationArea}
          onDragEnter={handleConversationDragEnter}
          onDragOver={handleConversationDragOver}
          onDragLeave={handleConversationDragLeave}
          onDrop={handleConversationDrop}
        >
          {isConversationDragActive && (
            <div className={classes.dragOverlay}>
              <div className={classes.dragOverlayContent}>
                <span>Solte o arquivo para anexar à conversa</span>
                <span style={{ fontSize: 13, fontWeight: 500, opacity: 0.8 }}>
                  Você também pode continuar enviando pelo botão +
                </span>
              </div>
            </div>
          )}

          <Paper elevation={0} style={{ borderTop: `1px solid ${theme.mode === "light" ? "rgba(148,163,184,0.16)" : "rgba(255,255,255,0.08)"}`, background: "transparent" }}>
            <TagsContainer contact={contact} />
          </Paper>
          <ReplyMessageProvider>
            <ForwardMessageProvider>
              <EditMessageProvider>
                {renderMessagesList()}
              </EditMessageProvider>
            </ForwardMessageProvider>
          </ReplyMessageProvider>
        </div>
      </Paper>

      <ContactDrawer
        open={drawerOpen}
        handleDrawerClose={handleDrawerClose}
        contact={contact}
        loading={loading}
        ticket={ticket}
      />

    </div>
  );
};

export default Ticket;
